import $ from 'jquery';

$.fn.hasAttr = function (attr) {
  var value = $(this).attr(attr);
  return typeof value !== typeof undefined && value !== false;
};
